/** A named workspace (MT5's profiles): the panels, the charts and their settings, saved to come back to. */
export interface Profile {
  layout: unknown;
  savedAt: string;
}

export type Profiles = Record<string, Profile>;

export const MAX_PROFILES = 5;
export const MAX_PROFILE_NAME = 30;

export const cleanProfileName = (name: string) => name.replace(/\s+/g, ' ').trim().slice(0, MAX_PROFILE_NAME);

/** Stored profiles, dropping anything malformed. */
export function normalizeProfiles(raw: unknown): Profiles {
  const out: Profiles = {};
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return out;
  for (const [name, value] of Object.entries(raw as Record<string, unknown>)) {
    const key = cleanProfileName(name);
    const p = value as Partial<Profile> | null;
    if (!key || !p || typeof p !== 'object' || typeof p.layout !== 'object' || p.layout === null) continue;
    out[key] = { layout: p.layout, savedAt: typeof p.savedAt === 'string' ? p.savedAt : '' };
    if (Object.keys(out).length >= MAX_PROFILES) break;
  }
  return out;
}

/** What stops a profile being saved under this name, or null. Saving over an existing one is allowed. */
export function profileNameProblem(name: string, existing: Profiles): string | null {
  const clean = cleanProfileName(name);
  if (!clean) return 'Give the profile a name.';
  if (!(clean in existing) && Object.keys(existing).length >= MAX_PROFILES)
    return `You can keep up to ${MAX_PROFILES} profiles. Delete one first.`;
  return null;
}
